import React, { Component } from 'react'
import s from './styles.scss'
import { Query, Mutation } from "react-apollo";
import gql from "graphql-tag";
import moment from 'moment'

import { Link } from 'react-router-dom'
import { Button } from 'sofia-ui'
import Modal from '../../../../components/Modal'
import { keyBy } from 'lodash'

const QUERY = gql`
query Request($uuid: String) {
  subjects {
    id
    _id
    name
  }
  request(_id: $uuid) {
    id
    _id
    state
    started
    start_date
    nbr_sessions
    nbr_sessions_week
    tutor_price
    parent_price
    sofia_price
    address
    precision_location
    survey
    show_survey
    completed
    submitted
    validated
    confirmed
    started
    ended
    canceled
    admin_notes
    client_notes
    tutor_notes
    description
    avaibilitys {
      id
      day
      start
      end
    }
    sessions {
      id
      _id
      state
      number
      date
      state
      time_begin
      time_end
    }
    request_students {
      id
      student {
        id
        _id
        first_name
        last_name
        sublevel
        level {
          id
          _id
          name
        }
      }
      subjects_uuids
    }
    tutor {
      id
      _id
      user {
				id
				_id
        first_name
        last_name
      }
    }
		client {
			id
			_id
			user {
				id
				_id
				first_name
				last_name
				email
				phone_number
			}
		}
  }
}
`

const UPDATE = gql`
mutation updateRequest($input: requestMutation) {
  updateRequest(input: $input) {
    state
    id
    _id
    admin_notes
    client_notes
    description
    tutor_notes
  }
}
`

const UPDATE_SESSION = gql`
mutation updateSession($input: sessionMutation) {
  updateSession(input: $input) {
    state
    id
    _id
  }
}
`

const dayToString = day => {
  switch (parseInt(day, 10)) {
    case 0:
      return "Sunday"
    case 1:
      return "Monday"
    case 2:
      return "Tuesday"
    case 3:
      return "Wednesday"
    case 4:
      return "Thursday"
    case 5:
      return "Friday"
    case 6:
      return "Saturday"
    default:
      return "Invalid"
  }
}

class RequestDetails extends Component {

	state = {
		modal: null
	}

  render() {

		if (!this.props.uuid) return null
		
		const { modal } = this.state

    return <Query
      query={QUERY}
      variables={{
        uuid: this.props.uuid
      }}
      >
      {({ loading, error, data, fetchMore }) => {
      if (loading) return null;
      if (error) {
        console.error(error)
        return <p>Error :(</p>
      };

      const { request_students, state, start_date, nbr_sessions, nbr_sessions_week, tutor, avaibilitys, sessions, tutor_price, parent_price, sofia_price, address,
        precision_location, client, survey, show_survey,
        completed,
        submitted,
        validated,
        confirmed,
        started,
        ended,
        canceled,
        client_notes,
        tutor_notes,
        description,
        admin_notes,
        id,
        _id } = data.request

      const optimisticRes = { 
        __typename: "Request",
        id,
        _id,
        state,
        admin_notes,
        client_notes,
        description,
        tutor_notes,
      }

      const subjectsByUuid = keyBy(data.subjects, '_id')

      return <Mutation mutation={UPDATE}>
        {(updateRequest, { data }) => (
          <div className={s.container}>

          <div className="split">

            <div className="split-larger">
              <div className="box inline">
                <h3>Students</h3>
                {request_students.map(({ student, subjects_uuids }, key) => <div key={key}>
                  <h4>{student.first_name}</h4>
                  <small>{student.level.name} • {student.sublevel}</small>

                  {subjects_uuids.map((_id) => <div key={_id}>{subjectsByUuid[_id].name}</div>)}

                </div>)}
              </div>

              <div className="box">
                <h3>Tutor</h3>
                {tutor && <React.Fragment>
                  <h4>{tutor.user.first_name} {tutor.user.last_name}</h4>
                  <Link to={`/users/tutor/${tutor.user._id}`}>
                    <Button small color='dark' inline>View profile</Button>
                  </Link>
                </React.Fragment>}

                <Button small color='blue' onClick={() => this.setState({ modal: 'changeTutor'})}>Change</Button>

                <Modal
                  title='Select tutor'
                  close={() => this.setState({ modal: null })}
                  hide={modal !== 'changeTutor'}
                >
                  <Mutation mutation={UPDATE}>
                    {(updateRequest, { data }) => (
                        <input type="text" className="small" defaultValue={tutor ? tutor.id : ''} placeholder="ID" onChange={e => updateRequest({ variables: { input: { _id: this.props.uuid, tutor_id: e.target.value.length ? e.target.value : null } } })} />
                    )}
                  </Mutation>
                  <br />
                  <Mutation mutation={UPDATE}>
                    {(updateRequest, { data }) => (
                        <input type="text" className="small" defaultValue={tutor ? tutor._id : ''} placeholder="UUID" onChange={e => updateRequest({ variables: { input: { _id: this.props.uuid, tutor_uuid: e.target.value.length ? e.target.value : null } } })} />
                    )}
                  </Mutation>
                </Modal>

              </div>

            </div>
          </div>

          <div className="box">
            <h3>Client</h3>
            {client && <React.Fragment>
              <h4>{client.user.first_name} {client.user.last_name}</h4>
              <small>{client.user.email} • {client.user.phone_number}</small> <br/><br />
              <Link to={`/users/client/${client.user._id}`}>
                <Button small color='dark' inline>View profile</Button>
              </Link>
            </React.Fragment>}

          </div>
    
          <div className="split">

            <div className="box inline">
              <div className="box">
                  <h3>Notes admin</h3>
                  <textarea value={admin_notes && admin_notes.length ? admin_notes : ''} rows={10} onChange={e => {
                    updateRequest({ 
                      variables: { input: { _id: this.props.uuid, admin_notes: e.target.value } },
                      optimisticResponse: { updateRequest: { ...optimisticRes, admin_notes: e.target.value } } 
                    })
                  }} />
              </div>
            </div>

            <div className="box inline">
              <div className="box">
                  <h3>Note pour le client</h3>
                  <textarea value={client_notes && client_notes.length? client_notes : ''} rows={2} onChange={e => updateRequest({ 
                    variables: { input: { _id: this.props.uuid, client_notes: e.target.value } }, 
                    optimisticResponse: { updateRequest: { ...optimisticRes, client_notes: e.target.value } } 
                  })} />
                  <small>Uniquement visible dans la demande pour client</small>

                  <h3>Note pour le tuteur</h3>
                  <textarea value={tutor_notes && tutor_notes.length? tutor_notes : ''} rows={2} onChange={e => updateRequest({ 
                    variables: { input: { _id: this.props.uuid, tutor_notes: e.target.value } }, 
                    optimisticResponse: { updateRequest: { ...optimisticRes, tutor_notes: e.target.value } }
                  })} />
                  <small>Uniquement visible dans la demande pour tuteur</small>

              </div>
            </div>
          
          </div>

          <div className="box">
            <h3>Détails du parent</h3>
            <textarea value={description && description.length? description : ''} rows={2} onBlur={e => updateRequest({ 
              variables: { input: { _id: this.props.uuid, description: e.target.value } },
              optimisticResponse: { updateRequest: { ...optimisticRes, description: e.target.value } } 
            })} />
            <br />
            <small>Visible par tout le monde</small>
          </div>

          <div className="box inline">
            <h3>Avaibilities</h3>
            {avaibilitys.map(({ day, start, end }) => <div>
              <b>{dayToString(day)}</b> {start.replace(/:00$/, '')} - {end.replace(/:00$/, '')}
            </div>)}
          </div>

          <div className="box">
            <h3>States</h3>

            <div className="flex f-align-center mb">
              <Mutation mutation={UPDATE}>
                {(updateRequest, { data }) => (
                    <div>
                      <input type="checkbox" id="s1"
                      defaultChecked={completed}
                      onChange={e => {
                        updateRequest({ variables: { input: { _id: this.props.uuid, completed: e.target.checked } } })
                      }}
                      />
                    <label htmlFor="s1"><div/> Nous avons reçu la demande</label>
                  </div>
                )}
              </Mutation>

              <Mutation mutation={UPDATE}>
                {(updateRequest, { data }) => (
                    <div>
                      <input type="checkbox" id="s2"
                      defaultChecked={submitted}
                      onChange={e => {
                        updateRequest({ variables: { input: { _id: this.props.uuid, submitted: e.target.checked } } })
                      }}
                      />
                    <label htmlFor="s2"><div/> Demande envoyée à des tuteurs</label>
                  </div>
                )}
              </Mutation>

              <Mutation mutation={UPDATE}>
                {(updateRequest, { data }) => (
                    <div>
                      <input type="checkbox" id="s3"
                      defaultChecked={validated}
                      onChange={e => {
                        updateRequest({ variables: { input: { _id: this.props.uuid, validated: e.target.checked } } })
                      }}
                      />
                    <label htmlFor="s3"><div/> Tuteur trouvé</label>
                  </div>
                )}
              </Mutation>

              <Mutation mutation={UPDATE}>
                {(updateRequest, { data }) => (
                    <div>
                      <input type="checkbox" id="s4"
                      defaultChecked={confirmed}
                      onChange={e => {
                        updateRequest({ variables: { input: { _id: this.props.uuid, confirmed: e.target.checked } } })
                      }}
                      />
                    <label htmlFor="s4"><div/> Première séance validée</label>
                  </div>
                )}
              </Mutation>

            </div>

            <div className="flex f-align-center mb">

              <Mutation mutation={UPDATE}>
                {(updateRequest, { data }) => (
                    <div>
                      <input type="checkbox" id="s5"
                      defaultChecked={started}
                      onChange={e => {
                        updateRequest({ variables: { input: { _id: this.props.uuid, started: e.target.checked } } })
                      }}
                      />
                    <label htmlFor="s5"><div/> Séances commencées</label>
                  </div>
                )}
              </Mutation>

              <Mutation mutation={UPDATE}>
                {(updateRequest, { data }) => (
                    <div>
                      <input type="checkbox" id="s6"
                      defaultChecked={ended}
                      onChange={e => {
                        updateRequest({ variables: { input: { _id: this.props.uuid, ended: e.target.checked } } })
                      }}
                      />
                    <label htmlFor="s6"><div/> Séances terminées</label>
                  </div>
                )}
              </Mutation>

            </div>

            <Mutation mutation={UPDATE}>
              {(updateRequest, { data }) => (
                  <div>
                    <input type="checkbox" id="s6"
                    defaultChecked={canceled}
                    onChange={e => {
                      updateRequest({ variables: { input: { _id: this.props.uuid, canceled: e.target.checked } } })
                    }}
                    />
                  <label htmlFor="s6"><div/> Demande annulée</label>
                </div>
              )}
            </Mutation>
                
          </div>

          

          <div className="box">
            <Mutation mutation={UPDATE}>
              {(updateRequest, { data }) => (<React.Fragment>
                <b>State: </b>
                  <select className="small" defaultValue={state} onChange={e => updateRequest({ variables: { input: { _id: this.props.uuid, state: e.target.value } } })}>
                    <option value="ENVOYEE">ENVOYEE</option>
                    <option value="ACCEPTEE">ACCEPTEE</option>
                    <option value="ANNULEE">ANNULEE</option>
                  </select>
                  <br/>
              </React.Fragment>)}
            </Mutation>
            
            <b>Nbr sessions: </b> {nbr_sessions} <br/>
            <b>Nbr sessions / week: </b> {nbr_sessions_week} <br/>
            <b>Start date: </b> {moment(start_date).format("DD/MM/YYYY")} <br/>
        </div>

      </div>
      )}
      </Mutation>

      }}
  </Query>
  }
}

export default RequestDetails;



// WEBPACK FOOTER //
// ./src/containers/requests/Details/tabs/general.js